// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (max-width: 1299px) {
    .Header_mobileHeaderWrap__0EZhg {
        position: relative;
        padding: 0 20px;
    }

    .Header_mobileHeaderInnerWrap__-gHea {
        display: block;
        width: 100%;
        height: 46px;
        background-color: #FFFFFF;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: solid 1px #E6E6E6;
    }

    .Header_mobileHeaderLogo__LZTd\\+ {
        display: block;
        height: 46px;
    }

    .Header_mobileHeaderBtn__SqaIh {
        display: flex;
        flex-flow: column;
        justify-content: center;
        gap: 4px;
        width: 20px;
        height: 20px;
        cursor: pointer;
    }

    .Header_mobileHeaderBtn__SqaIh > div {
        border: none;
        width: 20px;
        background-color: #222222;
        height: 2px;
    }

    .Header_mobileHeader__KkJr5 {
        position: absolute;
        top: 0;
        right: 0;
        width: 284px;
        height: 640px;
        background-color: #222222;
        display: flex;
        flex-direction: column;
        transition: 0.3s ease-out;
        opacity: 0;
    }

    .Header_mobileHeaderClose__D84BJ {
        position: absolute;
        top: 30px;
        right: 22px;
        width: 18px;
        height: 18px;
        cursor: pointer;
    }

    .Header_mobileHeaderClose__D84BJ > div:nth-child(1) {
        position: absolute;
        top: 47%;
        left: -20%;
        width: 25px;
        height: 1px;
        background-color: #FFFFFF;
        transform: rotate(45deg);
    }

    .Header_mobileHeaderClose__D84BJ > div:nth-child(2) {
        position: absolute;
        top: 47%;
        left: -20%;
        width: 25px;
        height: 1px;
        background-color: #FFFFFF;
        transform: rotate(-45deg);
    }

    .Header_wrap__gSG60 {
        width: 100vw;
        height: 84px;
        position: absolute;
        top: 0;
        z-index: 999;
    }
      
    .Header_topContainer__0ke3e {
        height: 48px;
        background-color: #222222;
        display: flex;
        padding: 0 20px;
        align-items: center;
        justify-content: flex-end;
        color: #FFFFFF;
        font-size: 14px;
        display: none;
    }
    
    .Header_mobileTopContainer__vnsWL {
        margin-top: auto;
        display: flex;
        flex-direction: column;
        gap: 10px;
        color: #FFFFFF;
        font-size: 12px;
    }

    .Header_bottomContainer__ZjvD\\+ {
        width: 1300px;
        margin: 0 auto;
        display: none;
    }

    .Header_bottomInnerContainer__iE4\\+R {
        height: 100px;
        background-color: #FFFFFF;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .Header_mobileBottomContainer__eJdbC {
        margin-top: 72px;
        display: flex;
        flex-direction: column;
        gap: 12px;
        color: #FFFFFF;
        font-size: 18px;
    }
    
    .Header_topItem__5k7\\+A {
    padding: 0 20px;
    cursor: pointer;
    height: inherit;
    display: flex;
    align-items: center;
    }

    .Header_topItem__5k7\\+A span {
        margin-right: 6px;
    }

    .Header_bold__V\\+E0Q {
        font-weight: 900;
    }

    .Header_bottomContentHover__CLcae {
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
    }

    .Header_close__2jBwv {
        transform: rotate(180deg);
    }

    .Header_bottomContentHover__CLcae > img {
        margin-right: 16px;
        cursor: pointer;
        transition: 0.3s ease-out;
    }

    .Header_bottomItem__SosWr {
        font-weight: 500;
        position: relative;
    }

    .Header_bottomItem__SosWr > a {
        text-decoration: none;
        height: inherit;
        padding: 0 20px;
        display: flex;
        align-items: center;
        color: #FFFFFF;
        font-size: 18px;
        display: block;
        color: #FFFFFF;
        font-size: 18px;
    }

    .Header_bottomItem__SosWr > span {
        text-decoration: none;
        height: inherit;
        padding: 0 20px;
        display: flex;
        align-items: center;
        color: #FFFFFF;
        font-size: 18px;
        cursor: default;
    }


    /* .bottomItem .active > .bottomContentHover > span {
        color: #DC140A !important;
    } */

    .Header_bottomItem__SosWr:hover > span,
    .Header_bottomItem__SosWr:hover > a span {
        color: #DC140A;
    }

    .Header_bottomContentHover__CLcae:hover > span,
    .Header_bottomContentHover__CLcae:hover > a span {
        cursor: default;
    }

    .Header_bottomItemSub__IY0L8 {
        transition: 0.3s ease-out;
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding: 6px 30px;
    }

    .Header_hide__rqpMH {
        opacity: 0;
    }

    .Header_hoverItem__sG-Pn {
        font-size: 16px;
        font-weight: 500;
    }

    .Header_hoverItem__sG-Pn > a {
        text-decoration: none;
        color: #A2A2A2;
        display: block;
        padding: 6px 0 0;
        font-weight: 400;
    }

    .Header_hamLogo__VYfUy {
        width: 68.33px;
        margin: 47px 0 20px 20px;
    }

    .Header_doubleContent__G8kOC {
        color: #A2A2A2 !important;
    }

    .Header_doubleContent__G8kOC > a > span {
        display: block;
        font-size: 12px;
        margin-top: 4px;
        text-decoration: none;
        color: #A2A2A2 !important;
    }
}

@media only screen and (min-width: 1300px) {
    .Header_wrap__gSG60 {
        width: 100%;
        height: 148px;
        position: fixed;
        z-index: 999;
    }
    
    .Header_topContainer__0ke3e {
        height: 48px;
        background-color: #222222;
        display: flex;
        padding: 0 20px;
        align-items: center;
        justify-content: flex-end;
        color: #FFFFFF;
        font-size: 14px;
    }
    
    .Header_bottomContainer__ZjvD\\+ {
        width: 100%;
        background-color: #FFFFFF;
    }

    .Header_bottomInnerContainer__iE4\\+R {
        margin: 0 auto;
        width: 1300px;
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-bottom: solid 1px #E6E6E6;
    }
    
    .Header_topItem__5k7\\+A {
    padding: 0 10px;
    cursor: pointer;
    height: inherit;
    display: flex;
    align-items: center;
    }

    .Header_topItem__5k7\\+A span {
        margin-right: 6px;
    }

    .Header_bold__V\\+E0Q {
        font-weight: 900;
    }

    .Header_bottomItem__SosWr {
        height: inherit;
        cursor: pointer;
        font-weight: 500;
        position: relative;
    }

    .Header_bottomItem__SosWr > a {
        text-decoration: none;
        height: inherit;
        padding: 0 32px;
        display: flex;
        align-items: center;
        color: #222222;
        font-size: 20px;
    }

    .Header_bottomItem__SosWr > a img {
        width: 131px;
    }

    .Header_bottomItem__SosWr > a span {
        color: #222222;
        font-size: 20px;
        display: block;
    }

    .Header_bottomItem__SosWr > span {
        text-decoration: none;
        height: inherit;
        padding: 0 32px;
        display: flex;
        align-items: center;
        /* color: #222222; */
        font-size: 20px;
        cursor: default;
    }

    .Header_bottomItem__SosWr:hover > span,
    .Header_bottomItem__SosWr:hover > a span {
        color: #DC140A;
    }

    .Header_bottomItem__SosWr:hover > .Header_bottomItemSub__IY0L8,
    .Header_bottomItem__SosWr:hover > .Header_bottomItemSub3__Cehye {
        top: 100%;
    }

    .Header_bottomItemSub__IY0L8 {
        width: 162px;
        position: absolute;
        top: -1px;
        left: 50%;
        transform: translateX(-50%);
        z-index: -1;
        transition: 0.3s ease-out;
    }

    .Header_bottomItemSub3__Cehye {
        width: 162px;
        position: absolute;
        top: -99px;
        left: 50%;
        transform: translateX(-50%);
        z-index: -1;
        transition: 0.3s ease-out;
    }

    .Header_hoverItem__sG-Pn {
        background-color: #FAFAFA;
        font-size: 18px;
        font-weight: 500;
        text-align: center;
    }

    .Header_hoverItem__sG-Pn > a {
        text-decoration: none;
        color: #222222;
        display: block;
        padding: 14px 0;
    }

    .Header_hoverItem__sG-Pn:first-child {
        border-top: 1px solid #DC140A;
    }

    .Header_hoverItem__sG-Pn:nth-child(n+2) {
        border-top: 1px solid #E8E8E8;
    }
    .Header_mobileHeaderWrap__0EZhg {
        display: none;
    }

    .Header_doubleContent__G8kOC {
        padding: 14px 0;
        color: #222222 !important;
    }

    .Header_doubleContent__G8kOC > a > span {
        display: block;
        font-size: 14px;
        margin-top: 4px;
        text-decoration: none;
        color: #222222 !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/css/Header.module.css"],"names":[],"mappings":"AAAA;IACI;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,WAAW;QACX,YAAY;QACZ,yBAAyB;QACzB,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;QACnB,gCAAgC;IACpC;;IAEA;QACI,cAAc;QACd,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,iBAAiB;QACjB,uBAAuB;QACvB,QAAQ;QACR,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,yBAAyB;QACzB,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,MAAM;QACN,QAAQ;QACR,YAAY;QACZ,aAAa;QACb,yBAAyB;QACzB,aAAa;QACb,sBAAsB;QACtB,yBAAyB;QACzB,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,WAAW;QACX,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,QAAQ;QACR,UAAU;QACV,WAAW;QACX,WAAW;QACX,yBAAyB;QACzB,wBAAwB;IAC5B;;IAEA;QACI,kBAAkB;QAClB,QAAQ;QACR,UAAU;QACV,WAAW;QACX,WAAW;QACX,yBAAyB;QACzB,yBAAyB;IAC7B;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,kBAAkB;QAClB,MAAM;QACN,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,yBAAyB;QACzB,aAAa;QACb,eAAe;QACf,mBAAmB;QACnB,yBAAyB;QACzB,cAAc;QACd,eAAe;QACf,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,aAAa;QACb,sBAAsB;QACtB,SAAS;QACT,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,cAAc;QACd,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,yBAAyB;QACzB,aAAa;QACb,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,aAAa;QACb,sBAAsB;QACtB,SAAS;QACT,cAAc;QACd,eAAe;IACnB;;IAEA;IACA,eAAe;IACf,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,aAAa;QACb,8BAA8B;IAClC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,qBAAqB;QACrB,eAAe;QACf,eAAe;QACf,aAAa;QACb,mBAAmB;QACnB,cAAc;QACd,eAAe;QACf,cAAc;QACd,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,qBAAqB;QACrB,eAAe;QACf,eAAe;QACf,aAAa;QACb,mBAAmB;QACnB,cAAc;QACd,eAAe;QACf,eAAe;IACnB;;;IAGA;;OAEG;;IAEH;;QAEI,cAAc;IAClB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,yBAAyB;QACzB,aAAa;QACb,sBAAsB;QACtB,QAAQ;QACR,iBAAiB;IACrB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,qBAAqB;QACrB,cAAc;QACd,cAAc;QACd,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,cAAc;QACd,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,cAAc;QACd,eAAe;QACf,eAAe;QACf,qBAAqB;QACrB,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,WAAW;QACX,aAAa;QACb,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,yBAAyB;QACzB,aAAa;QACb,eAAe;QACf,mBAAmB;QACnB,yBAAyB;QACzB,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,yBAAyB;IAC7B;;IAEA;QACI,cAAc;QACd,aAAa;QACb,aAAa;QACb,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,gCAAgC;IACpC;;IAEA;IACA,eAAe;IACf,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,qBAAqB;QACrB,eAAe;QACf,eAAe;QACf,aAAa;QACb,mBAAmB;QACnB,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,qBAAqB;QACrB,eAAe;QACf,eAAe;QACf,aAAa;QACb,mBAAmB;QACnB,oBAAoB;QACpB,eAAe;QACf,eAAe;IACnB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;;QAEI,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,kBAAkB;QAClB,SAAS;QACT,SAAS;QACT,2BAA2B;QAC3B,WAAW;QACX,yBAAyB;IAC7B;;IAEA;QACI,YAAY;QACZ,kBAAkB;QAClB,UAAU;QACV,SAAS;QACT,2BAA2B;QAC3B,WAAW;QACX,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;QACzB,eAAe;QACf,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,qBAAqB;QACrB,cAAc;QACd,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,6BAA6B;IACjC;IACA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,yBAAyB;IAC7B;;IAEA;QACI,cAAc;QACd,eAAe;QACf,eAAe;QACf,qBAAqB;QACrB,yBAAyB;IAC7B;AACJ","sourcesContent":["@media only screen and (max-width: 1299px) {\n    .mobileHeaderWrap {\n        position: relative;\n        padding: 0 20px;\n    }\n\n    .mobileHeaderInnerWrap {\n        display: block;\n        width: 100%;\n        height: 46px;\n        background-color: #FFFFFF;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        border-bottom: solid 1px #E6E6E6;\n    }\n\n    .mobileHeaderLogo {\n        display: block;\n        height: 46px;\n    }\n\n    .mobileHeaderBtn {\n        display: flex;\n        flex-flow: column;\n        justify-content: center;\n        gap: 4px;\n        width: 20px;\n        height: 20px;\n        cursor: pointer;\n    }\n\n    .mobileHeaderBtn > div {\n        border: none;\n        width: 20px;\n        background-color: #222222;\n        height: 2px;\n    }\n\n    .mobileHeader {\n        position: absolute;\n        top: 0;\n        right: 0;\n        width: 284px;\n        height: 640px;\n        background-color: #222222;\n        display: flex;\n        flex-direction: column;\n        transition: 0.3s ease-out;\n        opacity: 0;\n    }\n\n    .mobileHeaderClose {\n        position: absolute;\n        top: 30px;\n        right: 22px;\n        width: 18px;\n        height: 18px;\n        cursor: pointer;\n    }\n\n    .mobileHeaderClose > div:nth-child(1) {\n        position: absolute;\n        top: 47%;\n        left: -20%;\n        width: 25px;\n        height: 1px;\n        background-color: #FFFFFF;\n        transform: rotate(45deg);\n    }\n\n    .mobileHeaderClose > div:nth-child(2) {\n        position: absolute;\n        top: 47%;\n        left: -20%;\n        width: 25px;\n        height: 1px;\n        background-color: #FFFFFF;\n        transform: rotate(-45deg);\n    }\n\n    .wrap {\n        width: 100vw;\n        height: 84px;\n        position: absolute;\n        top: 0;\n        z-index: 999;\n    }\n      \n    .topContainer {\n        height: 48px;\n        background-color: #222222;\n        display: flex;\n        padding: 0 20px;\n        align-items: center;\n        justify-content: flex-end;\n        color: #FFFFFF;\n        font-size: 14px;\n        display: none;\n    }\n    \n    .mobileTopContainer {\n        margin-top: auto;\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n        color: #FFFFFF;\n        font-size: 12px;\n    }\n\n    .bottomContainer {\n        width: 1300px;\n        margin: 0 auto;\n        display: none;\n    }\n\n    .bottomInnerContainer {\n        height: 100px;\n        background-color: #FFFFFF;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .mobileBottomContainer {\n        margin-top: 72px;\n        display: flex;\n        flex-direction: column;\n        gap: 12px;\n        color: #FFFFFF;\n        font-size: 18px;\n    }\n    \n    .topItem {\n    padding: 0 20px;\n    cursor: pointer;\n    height: inherit;\n    display: flex;\n    align-items: center;\n    }\n\n    .topItem span {\n        margin-right: 6px;\n    }\n\n    .bold {\n        font-weight: 900;\n    }\n\n    .bottomContentHover {\n        padding: 0 20px;\n        display: flex;\n        justify-content: space-between;\n    }\n\n    .close {\n        transform: rotate(180deg);\n    }\n\n    .bottomContentHover > img {\n        margin-right: 16px;\n        cursor: pointer;\n        transition: 0.3s ease-out;\n    }\n\n    .bottomItem {\n        font-weight: 500;\n        position: relative;\n    }\n\n    .bottomItem > a {\n        text-decoration: none;\n        height: inherit;\n        padding: 0 20px;\n        display: flex;\n        align-items: center;\n        color: #FFFFFF;\n        font-size: 18px;\n        display: block;\n        color: #FFFFFF;\n        font-size: 18px;\n    }\n\n    .bottomItem > span {\n        text-decoration: none;\n        height: inherit;\n        padding: 0 20px;\n        display: flex;\n        align-items: center;\n        color: #FFFFFF;\n        font-size: 18px;\n        cursor: default;\n    }\n\n\n    /* .bottomItem .active > .bottomContentHover > span {\n        color: #DC140A !important;\n    } */\n\n    .bottomItem:hover > span,\n    .bottomItem:hover > a span {\n        color: #DC140A;\n    }\n\n    .bottomContentHover:hover > span,\n    .bottomContentHover:hover > a span {\n        cursor: default;\n    }\n\n    .bottomItemSub {\n        transition: 0.3s ease-out;\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n        padding: 6px 30px;\n    }\n\n    .hide {\n        opacity: 0;\n    }\n\n    .hoverItem {\n        font-size: 16px;\n        font-weight: 500;\n    }\n\n    .hoverItem > a {\n        text-decoration: none;\n        color: #A2A2A2;\n        display: block;\n        padding: 6px 0 0;\n        font-weight: 400;\n    }\n\n    .hamLogo {\n        width: 68.33px;\n        margin: 47px 0 20px 20px;\n    }\n\n    .doubleContent {\n        color: #A2A2A2 !important;\n    }\n\n    .doubleContent > a > span {\n        display: block;\n        font-size: 12px;\n        margin-top: 4px;\n        text-decoration: none;\n        color: #A2A2A2 !important;\n    }\n}\n\n@media only screen and (min-width: 1300px) {\n    .wrap {\n        width: 100%;\n        height: 148px;\n        position: fixed;\n        z-index: 999;\n    }\n    \n    .topContainer {\n        height: 48px;\n        background-color: #222222;\n        display: flex;\n        padding: 0 20px;\n        align-items: center;\n        justify-content: flex-end;\n        color: #FFFFFF;\n        font-size: 14px;\n    }\n    \n    .bottomContainer {\n        width: 100%;\n        background-color: #FFFFFF;\n    }\n\n    .bottomInnerContainer {\n        margin: 0 auto;\n        width: 1300px;\n        height: 100px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        border-bottom: solid 1px #E6E6E6;\n    }\n    \n    .topItem {\n    padding: 0 10px;\n    cursor: pointer;\n    height: inherit;\n    display: flex;\n    align-items: center;\n    }\n\n    .topItem span {\n        margin-right: 6px;\n    }\n\n    .bold {\n        font-weight: 900;\n    }\n\n    .bottomItem {\n        height: inherit;\n        cursor: pointer;\n        font-weight: 500;\n        position: relative;\n    }\n\n    .bottomItem > a {\n        text-decoration: none;\n        height: inherit;\n        padding: 0 32px;\n        display: flex;\n        align-items: center;\n        color: #222222;\n        font-size: 20px;\n    }\n\n    .bottomItem > a img {\n        width: 131px;\n    }\n\n    .bottomItem > a span {\n        color: #222222;\n        font-size: 20px;\n        display: block;\n    }\n\n    .bottomItem > span {\n        text-decoration: none;\n        height: inherit;\n        padding: 0 32px;\n        display: flex;\n        align-items: center;\n        /* color: #222222; */\n        font-size: 20px;\n        cursor: default;\n    }\n\n    .bottomItem:hover > span,\n    .bottomItem:hover > a span {\n        color: #DC140A;\n    }\n\n    .bottomItem:hover > .bottomItemSub,\n    .bottomItem:hover > .bottomItemSub3 {\n        top: 100%;\n    }\n\n    .bottomItemSub {\n        width: 162px;\n        position: absolute;\n        top: -1px;\n        left: 50%;\n        transform: translateX(-50%);\n        z-index: -1;\n        transition: 0.3s ease-out;\n    }\n\n    .bottomItemSub3 {\n        width: 162px;\n        position: absolute;\n        top: -99px;\n        left: 50%;\n        transform: translateX(-50%);\n        z-index: -1;\n        transition: 0.3s ease-out;\n    }\n\n    .hoverItem {\n        background-color: #FAFAFA;\n        font-size: 18px;\n        font-weight: 500;\n        text-align: center;\n    }\n\n    .hoverItem > a {\n        text-decoration: none;\n        color: #222222;\n        display: block;\n        padding: 14px 0;\n    }\n\n    .hoverItem:first-child {\n        border-top: 1px solid #DC140A;\n    }\n\n    .hoverItem:nth-child(n+2) {\n        border-top: 1px solid #E8E8E8;\n    }\n    .mobileHeaderWrap {\n        display: none;\n    }\n\n    .doubleContent {\n        padding: 14px 0;\n        color: #222222 !important;\n    }\n\n    .doubleContent > a > span {\n        display: block;\n        font-size: 14px;\n        margin-top: 4px;\n        text-decoration: none;\n        color: #222222 !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mobileHeaderWrap": `Header_mobileHeaderWrap__0EZhg`,
	"mobileHeaderInnerWrap": `Header_mobileHeaderInnerWrap__-gHea`,
	"mobileHeaderLogo": `Header_mobileHeaderLogo__LZTd+`,
	"mobileHeaderBtn": `Header_mobileHeaderBtn__SqaIh`,
	"mobileHeader": `Header_mobileHeader__KkJr5`,
	"mobileHeaderClose": `Header_mobileHeaderClose__D84BJ`,
	"wrap": `Header_wrap__gSG60`,
	"topContainer": `Header_topContainer__0ke3e`,
	"mobileTopContainer": `Header_mobileTopContainer__vnsWL`,
	"bottomContainer": `Header_bottomContainer__ZjvD+`,
	"bottomInnerContainer": `Header_bottomInnerContainer__iE4+R`,
	"mobileBottomContainer": `Header_mobileBottomContainer__eJdbC`,
	"topItem": `Header_topItem__5k7+A`,
	"bold": `Header_bold__V+E0Q`,
	"bottomContentHover": `Header_bottomContentHover__CLcae`,
	"close": `Header_close__2jBwv`,
	"bottomItem": `Header_bottomItem__SosWr`,
	"bottomItemSub": `Header_bottomItemSub__IY0L8`,
	"hide": `Header_hide__rqpMH`,
	"hoverItem": `Header_hoverItem__sG-Pn`,
	"hamLogo": `Header_hamLogo__VYfUy`,
	"doubleContent": `Header_doubleContent__G8kOC`,
	"bottomItemSub3": `Header_bottomItemSub3__Cehye`
};
export default ___CSS_LOADER_EXPORT___;
